<br><p-fieldset legend="Portarias de Nomeação" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="portNomeacaoComite"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Certificados" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="certificadosComite"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Atas" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="atainvestimentos"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Decreto Nomeação Gestor de Recursos" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="portnomeacaoGestorInv"></app-lista-arquivos>
</p-fieldset>
<!-- <br><p-fieldset legend="Certidões e Declarações (Portaria 9.907/2020)" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="certdeccomite"></app-lista-arquivos>
</p-fieldset> -->



